import { Action } from '@ngrx/store';
import { ApiCallResultModel, EventSeriesModel } from './helper.interface';

export const enum ActionTypes {
  GET_ALL_COUNTRIES = '[Helpers] get all countries from API',
  SET_ACTIVE_LANGUAGE = '[Helpers] set active language',
  SET_SUPPORTED_LANGUAGES = '[Helpers] set supported languages',
  ADD_ALL_COUNTRIES_TO_LIST = '[Helpers] Set all countries to select dropdown',
  SET_API_CALL_RESULT = '[Helpers] Set API call result',
  SET_SELF_REGISTRATION = '[Helpers] self registration url parameter',
  SET_EVENT_SERIES_PAGE = '[Helpers] Event series page url parameter',
  SET_IS_WIDGET = '[Helpers] Set a flag indicating widget',
  SET_SPINNER_VALUE = '[Helpers] Set spinner boolean value',
  SET_RELOAD_REQUIRED = '[Helpers] Set a flag indicating page reload is required',
  SET_IS_LOGOUT_PROCESSING = '[Helpers] Set is logout processing',
  SET_INITIALIZE_CONTEO_LOGIN = '[Helpers] Set initialize Conteo login',
  SET_REINITIALIZE_CONTEO_LOGIN = '[Helpers] Set reinitialize Conteo login',
  SET_LATEST_INITIALIZED_CONTEO_LOGIN_EXHIBITION_ID = '[Helpers] Set latest initialized Conteo login exhibition id',
  RESET_REDUCER = '[Helpers] reset reducer'
}
/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */

export class GetAllCountriesAction implements Action {
  readonly type = ActionTypes.GET_ALL_COUNTRIES;
}

export class AddAllCountriesToListAction implements Action {
  readonly type = ActionTypes.ADD_ALL_COUNTRIES_TO_LIST;
  constructor(public payload: Array<string>) {}
}

export class SetActiveLanguage implements Action {
  readonly type = ActionTypes.SET_ACTIVE_LANGUAGE;
  constructor(public payload: string) {}
}

export class SetSupportedLanguages implements Action {
  readonly type = ActionTypes.SET_SUPPORTED_LANGUAGES;
  constructor(public payload: string[]) {}
}

export class SetApiCallResult implements Action {
  readonly type = ActionTypes.SET_API_CALL_RESULT;
  constructor(public payload: ApiCallResultModel) {}
}

export class SetSelfRegistration implements Action {
  readonly type = ActionTypes.SET_SELF_REGISTRATION;
  constructor(public payload: boolean) {}
}

export class SetEventSeriesPage implements Action {
  readonly type = ActionTypes.SET_EVENT_SERIES_PAGE;
  constructor(public payload: EventSeriesModel | null) {}
}

export class SetIsWidget implements Action {
  readonly type = ActionTypes.SET_IS_WIDGET;
  constructor(public payload: boolean) {}
}

export class SetSpinnerValue implements Action {
  readonly type = ActionTypes.SET_SPINNER_VALUE;
  constructor(public payload: boolean) {}
}

export class SetReloadRequired implements Action {
  readonly type = ActionTypes.SET_RELOAD_REQUIRED;
  constructor(public payload: boolean) {}
}

export class SetIsLogoutProcessing implements Action {
  readonly type = ActionTypes.SET_IS_LOGOUT_PROCESSING;
  constructor(public payload: boolean) {}
}

export class SetInitializeConteoLogin implements Action {
  readonly type = ActionTypes.SET_INITIALIZE_CONTEO_LOGIN;
  constructor(public payload: boolean) {}
}

export class SetReinitializeConteoLogin implements Action {
  readonly type = ActionTypes.SET_REINITIALIZE_CONTEO_LOGIN;
  constructor(public payload: boolean) {}
}

export class SetLatestInitializedConteoLoginExhibitionId implements Action {
  readonly type = ActionTypes.SET_LATEST_INITIALIZED_CONTEO_LOGIN_EXHIBITION_ID;
  constructor(public payload: number | null) {}
}

export class ResetReducer implements Action {
  readonly type = ActionTypes.RESET_REDUCER;
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | GetAllCountriesAction
  | SetActiveLanguage
  | SetSupportedLanguages
  | AddAllCountriesToListAction
  | SetApiCallResult
  | SetSelfRegistration
  | SetEventSeriesPage
  | SetIsWidget
  | SetSpinnerValue
  | SetReloadRequired
  | SetIsLogoutProcessing
  | SetInitializeConteoLogin
  | SetReinitializeConteoLogin
  | SetLatestInitializedConteoLoginExhibitionId
  | ResetReducer;
